module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('equip-table', {
    attrs: {
      "title": "Billable Equipment",
      "title-heading": "h4",
      "site-id": this.siteId,
      "owner-id": this.ownerId,
      "site-data": _vm.siteData,
      "show-qr-code": _vm.showQrCode,
      "filter-col": "isBillable",
      "filter-val": "true"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0c90f7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/subcat/BillableEquipTable.vue
// module id = 1603
// module chunks = 0